function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M0 8.00006C0 11.0324 1.68716 13.6705 4.17391 15.0273V0.972778C1.68716 2.32962 0 4.96772 0 8.00006Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M7.99992 0C6.61398 0 5.31042 0.352594 4.17383 0.972719V15.0273C5.31042 15.6474 6.61398 16 7.99992 16C12.4182 16 15.9999 12.4183 15.9999 8C15.9999 3.58175 12.4182 0 7.99992 0Z",
  fill: "#496E2D"
}), React.createElement("path", {
  d: "M11.4202 9.32305C10.4081 10.0543 8.99474 9.8267 8.26349 8.81464C7.53217 7.80252 7.75983 6.38924 8.77192 5.65799C9.08749 5.42999 9.44205 5.29521 9.80277 5.24837C9.1088 5.14459 8.37521 5.30096 7.76155 5.74437C6.51592 6.64443 6.2357 8.38383 7.13573 9.62951C8.03577 10.8751 9.77521 11.1554 11.0209 10.2552C11.6346 9.81183 12.0134 9.16455 12.1327 8.47302C11.975 8.8007 11.7357 9.09502 11.4202 9.32305Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M11.3768 5.21753L11.9469 5.83194L12.7074 5.47969L12.2992 6.21169L12.8693 6.82615L12.0469 6.66412L11.6387 7.39619L11.5387 6.564L10.7163 6.40197L11.4768 6.04972L11.3768 5.21753Z",
  fill: "#F0F0F0"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgPakistan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPakistan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pakistan.1f0bb51f.svg";
export { ForwardRef as ReactComponent };